import script from "./TotalBill.vue?vue&type=script&setup=true&lang=js"
export * from "./TotalBill.vue?vue&type=script&setup=true&lang=js"

import "./TotalBill.vue?vue&type=style&index=0&id=0696d4d9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0696d4d9"]])

export default __exports__